import { useQuery } from '@tanstack/react-query';

import { PriceAvailabilityRequestStatus } from '../../../../types/PriceAvailabilityRequestsStatus';
import { PriceAvailabilityRequest } from '../../../common/api/clients/priceAvailability.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { useFlags } from '../../../common/launchDarkly/useFlags';

interface UsePriceAvailabilityCheckParams {
    offerId: string;
}

interface UsePriceAvailabilityCheckResult {
    hasPAI: boolean;
    request: PriceAvailabilityRequest | null;
}

export const usePriceAvailabilityCheck = ({ offerId }: UsePriceAvailabilityCheckParams) => {
    const flags = useFlags();

    return useQuery({
        ...queries.priceAvailability.byOfferId(offerId),
        enabled: flags.priceAvailabilityRequest,
        select: (data): UsePriceAvailabilityCheckResult => ({
            hasPAI: data !== null && data.status !== PriceAvailabilityRequestStatus.CANCELED,
            request: data,
        }),
    });
};
